module.exports = __webpack_public_path__ + "7de5e458af0645cb8abafccad2817a3d.svg";